module.exports = __webpack_public_path__ + "img/NascarBadgeGrey.5a116298.svg";